import React from 'react';
import { useDropzone } from 'react-dropzone';

import './fileDropzone.css';

export default function FileDropzone({
  onDrop,
  onDropRejected,
  accept,
  maxFiles = 1,
  maxSize,
  className = '',
  disabled = false,
  multiple,
}) {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDropRejected,
    accept,
    maxFiles,
    maxSize,
    multiple: multiple ?? maxFiles > 1,
    disabled,
  });

  return (
    <div
      {...getRootProps({
        className: `file-dropzone ${className}`.trim(),
      })}>
      <input {...getInputProps()} />
    </div>
  );
}
